// showCart AB实验 https://docs.corp.kuaishou.com/d/home/fcABqpJkU3GrrruaZeHXk2u_K#section=vodka.92phzv127u8h
// 缓存整个ab结果，避免多次请求

export function useShowCart(config = {}) {
    /** 
     * 实验推全
     * 加购：
        if_shopping_cart: true
        if_live_shopping_cart: true
        if_photo_shopping_cart: true

        加购样式： 
        add_to_cart_style
        （商详1  其他短视频&直播2） 
        if(config.isDetail) add_to_cart_style = 1
        else add_to_cart_style = 2

        店铺凑单：
        store_addon_style: 1
        if_detail_coupon_to_store: true
     */
    return {
        showCart: true,
        showCartStyle: config?.isDetail ? 1 : 2,
        storeAddonStyle: 1,
        isDetailCouponToMerchant: true,
    };
}
